import { render, staticRenderFns } from "./NewTree.vue?vue&type=template&id=578ce7b4&"
import script from "./NewTree.vue?vue&type=script&lang=js&"
export * from "./NewTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports